import React, {useMemo} from "react";
import {useTheme} from "styled-components";
import {ResponsiveProductCard, ProductCard, CartIconActions, SaleIndicator} from "@ui";
import useProductCard from "src/core/products/hooks/useProductCard";
import styles from "src/themes/flight/components/ProductCard/styles";
import Product from "src/core/common/models/product";
import useSite from "src/core/sites/hooks/useSite";
import {getFlowerTypeIndicatorProps} from "src/themes/flight/elements/flowerType";
import makeFlowerTypeIndicator from "@ui/components/FlowerTypeIndicator/makeFlowerTypeIndicator";

export default function BaseThemeProductCard({product, ...props}) {
  const site = useSite();
  const _product = product instanceof Product ? product : new Product(product);
  const {actionProps, cartProps, ...productCardProps} = useProductCard(_product);
  const theme = useTheme();

  const flowerTypeIndicatorProps = getFlowerTypeIndicatorProps(site, theme);

  const iconType = site.getUiConfiguration().flowerTypeIndicator.iconType;
  const FlowerTypeIndicator = makeFlowerTypeIndicator(iconType);

  const DesktopProductCard = useMemo(
    () => (
      <div>
        <ProductCard
          {...props}
          {...productCardProps}
          product={product}
          styles={styles(theme, site, {mode: props.mode})}
          potencyTagsPosition="bottom"
          flowerTypePosition={"custom"}
          brandNamePosition={"below-product-name"}
          sizesPosition={"below-potency-tags"}
          zoomOnHover={false}
          flowerTypeIndicatorProps={flowerTypeIndicatorProps}
          FlowerTypeIndicatorComponent={FlowerTypeIndicator}
          ActionsComponent={props => (
            <CartIconActions
              {...props}
              {...actionProps}
              discountPricePosition={"bottom"}
            />
          )}
          SaleIndicatorComponent={props =>
            productCardProps.onSale && <SaleIndicator {...props} position={"right"} />
          }
        />
      </div>
      // eslint-disable-next-line
    ),
    [props, productCardProps, product, theme, site, flowerTypeIndicatorProps, actionProps]
  );

  return (
    <ResponsiveProductCard
      DesktopProductCard={DesktopProductCard}
      TabletProductCard={DesktopProductCard}
      MobileProductCard={DesktopProductCard}
    />
  );
}
